export default __webpack_public_path__ + "static/media/singleFlower.542783d6.svg";